<template>
  <div class="page_noApplicationInv">
    <div class="topOperation">
      <div class="top-left">
        <ShowNavHead />
      </div>
    </div>
    <div class="main-con">
      <div class="crumbs">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item>收支</el-breadcrumb-item>
          <el-breadcrumb-item :to="{ path: '/invoicing' }">开票</el-breadcrumb-item>
          <el-breadcrumb-item>无申请开票</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <div class="ftabs">
        <div class="p_employee_box">
          <div class="p_employee_list">
            <el-form :rules="formRules" :inline="true" ref="statementForm" :model="formQuery" label-width="80px">
              <el-form-item label="归属:" prop="type">
                <div class="i_radio_box">
                  <el-radio-group v-model="formQuery.type">
                    <el-radio :label="1">项目</el-radio>
                    <el-radio :label="2">内部部门</el-radio>
                  </el-radio-group>
                  <div class="i_box">
                    <el-select v-model="formQuery.ownershipId" v-if="formQuery.type == 1" placeholder="请选择项目" size="small" @change="getDetail" filterable clearable style="width: 140px">
                      <el-option v-for="item in projectList" :key="item.Id" :label="item.StrprojectName" :value="item.Projectid"></el-option>
                    </el-select>
                    <el-cascader v-if="formQuery.type == 2" v-model="dedpartDiaVal" size="small" :props="props" clearable filterable :options="departList" placeholder="请选择部门" @change="departChange" style="width: 140px"></el-cascader>
                  </div>
                </div>
              </el-form-item>
              <el-form-item :label="formQuery.type==1 ? '商务合同主体:' : '法务主体:'" label-width="125px" prop="subjectOfLegalAffairsId">
                <el-select v-model="formQuery.subjectOfLegalAffairsId" placeholder="" size="small" style="width: 320px" clearable filterable @change="changeLeg">
                  <el-option v-for="(item, index) in legList" :key="index" :label="item.value" :value="item.key"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="客户名称:" v-if="formQuery.type == 1">
                <span>{{ custname }}</span>
              </el-form-item>
              <el-form-item label="账户类别:">
                <el-radio-group v-model="formQuery.xAccount.accountType" @input="changeAccountType">
                  <el-radio :label="0">基本户</el-radio>
                  <el-radio :label="1">一般户</el-radio>
                </el-radio-group>
              </el-form-item>
              <el-form-item label="销方开户行/账号:" v-if="formQuery.xAccount.accountType==1" label-width="140px">
                <el-select v-model="formQuery.xAccount.bankAccount" placeholder="" size="small" @change="changeBankAccount" filterable clearable style="width: 300px">
                  <el-option v-for="item in accountList" :key="item.value" :label="item.key" :value="item.value"></el-option>
                </el-select>
              </el-form-item>
            </el-form>
          </div>
          <div>
            <!-- 开票抬头 -->
            <div class="p_employee_list mt15">
              <div class="flex aic">
                <div class="r_edit_title">
                  <div class="line_box"></div>
                  第一步：填写开票抬头
                </div>
                <div class="tips">说明：可在项目账套中添加好客户开票抬头，系统自动读取</div>
              </div>
              <div class="com_style pt20 mt15">
                <el-form :model="formQuery" :inline="true" :rules="formRules" ref="statementForm1" label-width="110px">
                  <el-form-item label="开票抬头:" prop="invoiceTitle">
                    <el-select v-model="invoiceTitle" placeholder="" size="small" clearable filterable @change="changeInvoiceTitle" value-key="id">
                      <el-option v-for="(item, index) in invoiceTitles" :key="index" :label="item.accountName" :value="item"></el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item label="使用新抬头:">
                    <el-input v-model="formQuery.newInvoiceTitle" @input="changeNewTitle" size="small" clearable></el-input>
                  </el-form-item>
                  <el-form-item label="纳税人识别号:" prop="ratepayerNo">
                    <el-input v-model="formQuery.ratepayerNo" size="small" clearable></el-input>
                  </el-form-item>
                  <el-form-item label="营业地址:">
                    <el-input v-model="formQuery.businessAddress" size="small" clearable></el-input>
                  </el-form-item>
                  <el-form-item label="开户行:">
                    <el-input v-model="formQuery.bankOfDeposit" size="small" clearable></el-input>
                  </el-form-item>
                  <el-form-item label="账号:">
                    <el-input v-model="formQuery.accountNumber" size="small" clearable></el-input>
                  </el-form-item>
                  <el-form-item label="电话:">
                    <el-input v-model="formQuery.telephone" size="small" clearable></el-input>
                  </el-form-item>
                </el-form>
              </div>
            </div>

            <!-- 填写开票内容 -->
            <div class="p_employee_list mt15">
              <div class="r_edit_title">
                <div class="line_box"></div>
                第二步：填写开票内容
              </div>

              <div class="com_style pt20 mt15">
                <el-form :inline="true" :rules="formRules" ref="statementForm" :model="formQuery" label-width="100px">
                  <el-form-item label="开票方式:">
                    <div class="f_sel_box flex">
                      <el-select class="f_sel01" v-model="Billing2" placeholder="" size="small" @change="changeBilling" filterable clearable style="width: 180px">
                        <el-option v-for="(item, index) in BillingList" :key="index" :label="item.value" :value="item"></el-option>
                      </el-select>
                      <el-checkbox v-model="formQuery.isConsolidatedBilling" :true-label="1" :false-label="0" v-if="Billing != undefined && Billing.indexOf('差额') > -1" style="margin-left: 15px;" @change="changeConsolidatedBilling">合并开票</el-checkbox>
                    </div>
                  </el-form-item>
                  <el-form-item label="票种:" label-width="60px" v-if="Billing != undefined && (Billing.indexOf('全额') > -1 || formQuery.isConsolidatedBilling==1)">
                    <el-select v-model="invoiceTypeId" placeholder="" size="small" style="width: 110px" filterable clearable value-key="key" @change="changeTicketTypeId">
                      <el-option v-for="(item, index) in ticketTypeList" :key="index" :label="item.value" :value="item"></el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item label="特殊要求:" label-width="100px">
                    <el-checkbox v-model="formQuery.isPolymerization" :true-label="1" :false-label="0">相同发票类型和开票内容合并开具</el-checkbox>
                  </el-form-item>
                  <div v-if="Billing != undefined && (Billing.indexOf('全额') > -1 && formQuery.actualBillingTakeOut==null) || formQuery.isConsolidatedBilling==1">
                    <div v-for="(item,index) in formQuery.actualBillingMain.details" :key="index">
                      <el-form-item label="开票内容:">
                        <el-select v-model="item.billingItemDetailsId" placeholder="" size="small" filterable clearable value-key="key" style="width: 180px" @change="changeBillingItemDetails">
                          <el-option v-for="(item, index) in BillingConList" :key="index" :label="item.value" :value="item.key"></el-option>
                        </el-select>
                      </el-form-item>

                      <!-- <el-form-item label="开票金额:" label-width="80px">
                        <el-input type="number" v-model="item.invoiceAmount" size="small" style="width: 90px;" @blur="calMtpt"></el-input>
                      </el-form-item> -->
                      <el-form-item label="开票金额:" v-if="formQuery.actualBillingMain!=null" type="number" label-width="80px">
                        <el-select v-model="formQuery.actualBillingMain.details[0].taxInclusiveLabel" placeholder="" size="small" style="width: 90px;margin-right: 15px" @change="calMtpt">
                          <el-option label="含税" :value="1"></el-option>
                          <el-option label="不含税" :value="0"></el-option>
                        </el-select>
                        <el-input v-model="formQuery.actualBillingMain.details[0].invoiceAmount" size="small" clearable style="width: 120px" @blur="calMtpt"></el-input>
                      </el-form-item>

                      <el-form-item label="项目申报代码:" label-width="110px">
                        <el-select v-model="formQuery.actualBillingMain.projectKey" placeholder="" size="small" style="width: 140px" filterable value-key="key">
                          <el-option v-for="(item, index) in projectKeyList" :key="index" :label="item.value" :value="item.key"></el-option>
                        </el-select>
                      </el-form-item>

                      <el-form-item v-if="formQuery.isConsolidatedBilling==0">
                        <div class="injuryTabBtn">
                          <el-button type="text" @click="addContentHandle()">+ 添加</el-button>
                          <el-button type="text" v-if="index!=0" @click="dltContentHandle(index)">删除</el-button>
                        </div>
                      </el-form-item>
                      <el-form-item label="价税合计:" label-width="80px" v-if="index==formQuery.actualBillingMain.details.length - 1 && formQuery.isConsolidatedBilling!=1">
                        <span style="font-weight: bold">￥{{ mTpt.toFixed(2) }}</span>
                      </el-form-item>

                      <div class="flex" style="padding-left: 610px;">
                        <el-form-item label="数量:" label-width="50px">
                          <el-input type="number" v-model="item.quantity" size="small" style="width: 60px;"></el-input>
                        </el-form-item>
                        <el-form-item label="单位:" label-width="50px">
                          <el-input v-model="item.unit" size="small" style="width: 60px;"></el-input>
                        </el-form-item>
                        <el-form-item label="规格:" label-width="50px">
                          <el-input v-model="item.specification" size="small" style="width: 60px;"></el-input>
                        </el-form-item>
                      </div>
                    </div>
                  </div>
                  <div class="ceBox" style="overflow: hidden;" v-if="formQuery.actualBillingTakeOut!=null">
                    <div class="flex" v-if="formQuery.actualBillingMain!=null && formQuery.isConsolidatedBilling != 1">
                      <!-- <div class="ceTitle" v-if="formQuery.isConsolidatedBilling == 0">服务费</div> -->
                      <el-form-item label="开票内容:" :style="formQuery.isConsolidatedBilling == 0 ? 'margin-left:50px' : 'margin-left:13px'">
                        <el-select v-model="formQuery.actualBillingMain.details[0].billingItemDetailsId" placeholder="" size="small" filterable clearable value-key="key" style="width: 180px" @change="changeBillingItemDetails">
                          <el-option v-for="(item, index) in BillingConList" :key="index" :label="item.value" :value="item.key"></el-option>
                        </el-select>
                      </el-form-item>
                      <el-form-item label="票种:" label-width="60px" v-if="formQuery.isConsolidatedBilling == 1">
                        <el-select v-model="invoiceTypeId" placeholder="" size="small" style="width: 120px" filterable clearable @change="changeTicketTypeId" value-key="key">
                          <el-option v-for="(item, index) in ticketTypeList" :key="index" :label="item.value" :value="item"></el-option>
                        </el-select>
                      </el-form-item>
                      <el-form-item label="开票金额:" v-if="formQuery.actualBillingMain!=null" type="number" label-width="80px">
                        <el-select v-model="formQuery.actualBillingMain.details[0].taxInclusiveLabel" placeholder="" size="small" style="width: 90px;margin-right: 15px">
                          <el-option label="含税" :value="1"></el-option>
                          <el-option label="不含税" :value="0"></el-option>
                        </el-select>
                        <el-input v-model="formQuery.actualBillingMain.details[0].invoiceAmount" size="small" clearable style="width: 120px"></el-input>
                      </el-form-item>
                      <el-form-item label="项目申报代码:" label-width="110px">
                        <el-select v-model="formQuery.actualBillingMain.projectKey" placeholder="" size="small" style="width: 120px" filterable value-key="key">
                          <el-option v-for="(item, index) in projectKeyList" :key="index" :label="item.value" :value="item.key"></el-option>
                        </el-select>
                      </el-form-item>
                      <el-form-item label="数量:" label-width="50px">
                        <el-input type="number" v-model="formQuery.actualBillingMain.details[0].quantity" size="small" style="width: 60px;"></el-input>
                      </el-form-item>
                      <el-form-item label="单位:" label-width="50px">
                        <el-input v-model="formQuery.actualBillingMain.details[0].unit" size="small" style="width: 60px;"></el-input>
                      </el-form-item>
                      <el-form-item label="规格:" label-width="50px">
                        <el-input v-model="formQuery.actualBillingMain.details[0].specification" size="small" style="width: 60px;"></el-input>
                      </el-form-item>
                      <!-- 
                  <el-form-item label="价税合计:" type="number" label-width="80px" :prop="formQuery.isConsolidatedBilling==1 ? 'actualBillingMain.invoiceAmount' : ''">
                    ￥：{{ formQuery.actualBillingMain.taxInclusiveLabel == 0 ? formQuery.actualBillingMain.invoiceAmount * (rate + 1) :  formQuery.actualBillingMain.invoiceAmount }}
                  </el-form-item> -->

                    </div>
                    <!-- <div v-if="formQuery.actualBillingMain!=null" class="deductionAmountSum" style="float: right">价税合计:￥：{{ formQuery.actualBillingMain.details[0].taxInclusiveLabel == 0 ? (formQuery.actualBillingMain.details[0].invoiceAmount * (rate + 1)).toFixed(2) :  (formQuery.actualBillingMain.details[0].invoiceAmount).toFixed(2) }}</div> -->

                    <div class="flex" style="margin-top: 20px;">
                      <!-- <div class="ceTitle">{{ formQuery.isConsolidatedBilling == 0 ? '工资社保等' : '工资社保等（扣除部分）'}}</div> -->
                      <div>
                        <div v-if="formQuery.isConsolidatedBilling == 0" style="margin-left: -24px;">
                          <el-form-item label="开票方式:" v-if="formQuery.actualBillingTakeOut!=null &&formQuery.actualBillingMain!=null">
                            <el-select class="f_sel01" v-model="formQuery.actualBillingTakeOut.billingItemId" placeholder="" size="small" filterable clearable @change="changeBilling2" style="width: 180px;">
                              <el-option v-for="(item, index) in BillingList" :key="index" :label="item.value" :value="item.key"></el-option>
                            </el-select>
                          </el-form-item>
                          <el-form-item label="票种:" label-width="60px">
                            <el-select v-model="formQuery.actualBillingTakeOut.invoiceTypeId" placeholder="" size="small" style="width: 120px" filterable clearable @change="changeInvoiceType2">
                              <el-option v-for="(item, index) in ticketTypeList2" :key="index" :label="item.value" :value="item.key"></el-option>
                            </el-select>
                          </el-form-item>
                          <el-form-item label="数量:" label-width="50px">
                            <el-input type="number" v-model="formQuery.actualBillingTakeOut.details[0].quantity" size="small" style="width: 80px;"></el-input>
                          </el-form-item>
                          <el-form-item label="单位:" label-width="50px">
                            <el-input v-model="formQuery.actualBillingTakeOut.details[0].unit" size="small" style="width: 80px;"></el-input>
                          </el-form-item>
                          <el-form-item label="规格:" label-width="50px">
                            <el-input v-model="formQuery.actualBillingTakeOut.details[0].specification" size="small" style="width: 80px;"></el-input>
                          </el-form-item>
                          <!-- <el-form-item label="开票金额:" label-width="80px">
                        <el-select v-model="taxInclusiveLabel" placeholder="" size="small" style="width: 90px;margin-right: 15px">
                          <el-option label="含税" :value="1"></el-option>
                          <el-option label="不含税" :value="0"></el-option>
                        </el-select>
                        <el-input v-model="kcamount" size="small" type="number" clearable style="width: 120px"></el-input>
                      </el-form-item> -->
                        </div>
                        <div :class="formQuery.isConsolidatedBilling == 0 ? 'ckbox flex' : 'ckbox2 flex'" v-for="(item,index) in formQuery.actualBillingTakeOut.details" :key="index" style="width: 100%;">
                          <div v-if="formQuery.isConsolidatedBilling == 0" class="kcTitle">开票内容：</div>
                          <el-select v-if="formQuery.isConsolidatedBilling == 0" v-model="item.billingItemDetailsId" placeholder="" size="small" filterable clearable value-key="key" style="width: 180px;margin-right: 10px" @change="changeBillingItemDetails2">
                            <el-option v-for="(item, index) in BillingConList2" :key="index" :label="item.value" :value="item.key"></el-option>
                          </el-select>
                          <div class="kcTitle">扣除项目：</div>
                          <el-input v-model="item.projectName" placeholder="输入扣除项目" size="small" clearable style="width:100px"></el-input>
                          <div class="kcTitle">扣除金额：</div>
                          <el-input v-model="item.deductionAmount" placeholder="输入扣除金额" size="small" type="number" clearable style="width:100px;margin-right:10px" @blur="getDeductionAmountSum"></el-input>
                          <div class="kcTitle" v-if="formQuery.isConsolidatedBilling==0">项目申报代码：</div>
                          <el-select v-model="formQuery.actualBillingTakeOut.projectKey" placeholder="" size="small" style="width: 120px" filterable value-key="key" v-if="formQuery.isConsolidatedBilling==0">
                            <el-option v-for="(item, index) in projectKeyList2" :key="index" :label="item.value" :value="item.key"></el-option>
                          </el-select>
                          <div class="blueName cp addbtn" v-if="index==0" @click="addKcItem">+添加</div>
                          <div class="blueName cp addbtn" v-if="index!=0" @click="delKcItem(index)">删除</div>
                          <div class="deductionAmountSum" v-if="index==formQuery.actualBillingTakeOut.details.length - 1">扣除合计：￥{{deductionAmountSum}}</div>
                          <div class="deductionAmountSum" v-if="formQuery.actualBillingMain!=null && index==formQuery.actualBillingTakeOut.details.length - 1">价税合计: ￥{{ formQuery.actualBillingMain.details[0].taxInclusiveLabel == 0 ? (Number(formQuery.actualBillingMain.details[0].invoiceAmount * (rate + 1)) + Number(deductionAmountSum)).toFixed(2) : ( Number(formQuery.actualBillingMain.details[0].invoiceAmount) + Number(deductionAmountSum)).toFixed(2) }}</div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div v-if="isBuild">
                    <div class="r_edit_title">
                      <div class="line_box"></div>
                      建筑服务补充信息
                    </div>
                    <el-form-item label="土地增值税项目编号:" label-width="160px">
                      <el-input v-model="formQuery.buildingData.landValueTaxNo" size="small" clearable></el-input>
                    </el-form-item>
                    <el-form-item label="建筑服务发生地:" label-width="160px">
                      <el-input v-model="formQuery.buildingData.buildingServiceSite" size="small" clearable></el-input>
                    </el-form-item>
                    <el-form-item label="详细地址:" label-width="160px">
                      <el-input v-model="formQuery.buildingData.detailedAddress" size="small" clearable></el-input>
                    </el-form-item>
                    <el-form-item label="建筑项目名称:" label-width="160px">
                      <el-input v-model="formQuery.buildingData.buildingName" size="small" clearable></el-input>
                    </el-form-item>
                    <el-form-item label="跨地市标志:" label-width="160px">
                      <el-select v-model="formQuery.buildingData.crossCitySigns" placeholder="" size="small" clearable filterable>
                        <el-option label="是" :value="1"></el-option>
                        <el-option label="否" :value="0"></el-option>
                      </el-select>
                    </el-form-item>
                  </div>

                </el-form>
              </div>
            </div>

            <!-- 选择结算单 -->
            <div class="flex aic" style="margin-top: 15px;">
              <div class="r_edit_title">
                <div class="line_box"></div>
                第三步：选择结算单
              </div>
              <div class="redTips">结算单至少勾选一条，且合计开票金额需等于价税合计</div>
            </div>
            <div class="post_list mt15">
              <el-table border @selection-change="handleSelectionChange" :data="finalStatement" ref="multipleTable" class="doc_table" style="width: 100%">
                <el-table-column type="selection" width="55" align="center"></el-table-column>
                <!-- 项目或部门 -->
                <el-table-column align="center" prop="ownershipName" label="项目" min-width="140px">
                </el-table-column>
                <el-table-column align="center" prop="ownershipMonth" label="归属月" min-width="100px" fit :show-overflow-tooltip="true">
                </el-table-column>
                <el-table-column align="center" prop="finalStatementNo" label="结算单编号" min-width="120px" fit :show-overflow-tooltip="true">
                </el-table-column>
                <el-table-column align="center" prop="amount" label="结算单金额" min-width="100px" fit :show-overflow-tooltip="true">
                </el-table-column>
                <el-table-column align="center" prop="remaining" label="剩余待开金额" min-width="110px" fit :show-overflow-tooltip="true">
                </el-table-column>
                <el-table-column align="center" label="本次开具金额" width="160px" fit :show-overflow-tooltip="true">
                  <template slot-scope="{ row }">
                    <span class="req">*</span>
                    <el-input type="number" v-model="row.ttAmount" size="small" @blur="changeTTAmount(i)" clearable style="width:110px"></el-input>
                  </template>
                </el-table-column>
                <el-table-column align="center" label="创建时间" min-width="120px" fit :show-overflow-tooltip="true">
                  <template slot-scope="{ row }">
                    <span>{{
            row.createTime ? row.createTime.replace("T", " ") : ""
          }}</span>
                  </template>
                </el-table-column>
                <el-table-column align="center" label="附件" min-width="100px" fit :show-overflow-tooltip="true">
                  <template slot-scope="{row}">
                    <div class="blueName cp" v-for="(item,index) in row.files" :key="index" @click="down(item.fileUrl,item.fileName)">{{ item.fileName }}</div>
                  </template>
                </el-table-column>
              </el-table>
            </div>
            <div class="com_style mt15 f_com_box">
              <div class="flex_box flex">
                <div class="f_list_box flex">
                  <div class="f_left_box">合计开票金额:</div>
                  <div class="f_right_box">￥{{ settlementAmountSum }}</div>
                </div>
                <div class="f_list_box flex">
                  <div class="f_left_box">结算单:</div>
                  <div class="f_right_box">
                    <i class="el-icon-document f_icon"></i>
                  </div>
                </div>
                <div class="f_list_box flex">
                  <div class="f_left_box">客户扣款金额:</div>
                  <div class="f_right_box">
                    <el-input v-model="formQuery.deductionAmount" size="small" clearable></el-input>
                  </div>
                </div>
              </div>
            </div>
            <div class="com_style mt15 f_com_box f_foot_box">
              <div class="f_foot_box flex">
                <el-checkbox v-model="formQuery.isInvoiceMail" :true-label="1" :false-label="0">是否自动邮件发送电子/数电发票</el-checkbox>
                <div class="flex f_foot">
                  <div class="foot_left_box">接收邮箱</div>
                  <div class="flex">
                    <el-select v-model="formQuery.projectEmailIds" placeholder="" size="small" multiple filterable style="width: 300px">
                      <el-option v-for="(item, index) in emailList" :key="index" :label="item.value" :value="item.key"></el-option>
                    </el-select>
                    <el-input class="t_sel" v-model="formQuery.newEmail" size="small" placeholder="输入其他电子邮箱" clearable></el-input>
                  </div>
                </div>
                <div class="kptip">可添加多个邮箱，用英文格式的“;”隔开，如aaa@jobstart.cn;bbb@jobstart.cn</div>
              </div>
              <div class="f_foot_box flex mt15">
                <el-checkbox v-model="formQuery.isStatementMail" :true-label="1" :false-label="0">费用结算单盖章一并电子邮件发送</el-checkbox>
                <div class="flex f_foot">
                  <el-upload class="upload-demo" ref="file" action="#" :on-change="success_handle" :auto-upload="false" :limit="5" :on-remove="handleFileRemove" :on-exceed="handleExceed" :file-list="stateFileList">
                    <el-button size="small" type="primary">上传结算单</el-button>
                  </el-upload>
                </div>
              </div>
            </div>

            <div class="p_employee_list mt15">
              <el-form :inline="true" label-width="90px">
                <el-form-item label="开票备注:" prop="billingNote">
                  <el-input v-model="formQuery.billingNote" type="textarea" :autosize="{ minRows: 1}" size="small" clearable style="width: 300px;"></el-input>
                  <div class="tips" style="
                margin-left: 0;">注：显示在发票上</div>
                </el-form-item>
              </el-form>
            </div>
          </div>
          <!-- 开票无申请 -->
          <div class="btn_box">
            <el-button type="success" @click="submit(false)" :loading="isBtnLoading">在线开票</el-button>
            <el-button type="primary" @click="submit(true)" :loading="isBtnLoading">登记手工开票</el-button>
            <el-button @click="backHandle">取消</el-button>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
  import xz from "../../common";
  import * as math from 'mathjs'
  export default {
    data() {
      var validatetInvoiceTitle = (rule, value, callback) => {
        if (!this.formQuery.invoiceTitle && !this.formQuery.newInvoiceTitle) {
          callback(new Error("请选择开票抬头"));
        } else {
          callback();
        }
      };
      return {
        isBtnLoading: false,
        userId: Cookies.get("userid-b"),
        roleType: localStorage.loginRoletype,
        formQuery: {
          invoiceTitle: "",
          newInvoiceTitle: "",
          ratepayerNo: "",
          businessAddress: "",
          bankOfDeposit: "",
          accountNumber: "",
          telephone: "",
          isConsolidatedBilling: 0,
          isStatementMail: 0,
          isInvoiceMail: 0,
          deductionAmount: 0,
          newEmail: "",
          billingNote: "",
          type: 1,
          ownershipId: "",
          subjectOfLegalAffairsId: "",
          xAccount: {
            accountType: 0, //账户类别0：基本户1：一般户
            openingBank: '',
            bankAccount: '',
          },
          invoiceForFinalStatementsList: [{
            invoiceForFinalStatementId: "",
            finalStatementId: "",
            amount: 0
          }],
          projectEmailIds: [],
          invoiceFiles: [{
            fileUrl: "",
            fileName: ""
          }],
          buildingData: {
            landValueTaxNo: "",
            buildingServiceSite: "",
            detailedAddress: "",
            buildingName: "",
            crossCitySigns: 0
          },
          isPolymerization: 1,
          actualBillingMain: null,
          actualBillingTakeOut: null,
          isOffline: false, //是否线下申请（手工）
          sfzsxsfyhzh: true, //是否在展示销售方银行信息
          sfzsgmfyhzh: false, //是否展示购买方银行信息
          isautoremark: true,
          gmfxxsfqr: false, //购买方信息是否确认
          sxeddefptxgz: false, //是否确认开具大额发票
          spflxqr: false, //是否确认受票方为单位
          drawer: Cookies.get("userid-b"), //开票人
        },
        stateFileList: [],
        invoiceTitle: '',
        finalStatement: [],
        invoiceTitles: [],
        accountList: [],
        emailList: [],
        legList: [],
        custname: '',
        settlementAmountSum: 0, //合计开票金额
        multipleSelection: [],
        projectList: [], //项目列表
        departList: [], //部门列表
        dedpartDiaVal: [],
        BillingList: [], //开票方式列表
        Billing: '', //开票方式
        Billing2: '', //开票方式
        billingItemDetails: '', //开票内容
        ticketTypeList: [],
        BillingConList: [], //开票内容列表
        businessTypeId: '',
        invoiceTypeId: '', //票种
        ticketTypeList2: [],
        rate: 0, //税率
        deductionAmountSum: 0, //扣除合计
        BillingConList2: [],
        rate: null,
        mTpt: 0,
        taxRate: 0,
        props: {
          label: "strorganname",
          value: "strorgancode",
          children: "children",
          checkStrictly: true,
        },
        isBuild: false,
        projectKeyList: [],
        projectKeyList2: [],
        formRules: {
          type: {
            required: true,
            message: "请选择归属",
            trigger: "change",
          },
          subjectOfLegalAffairsId: {
            required: true,
            message: "请选择法务实体",
            trigger: "change",
          },
          'invoiceTitle': {
            required: true,
            validator: validatetInvoiceTitle,
            message: "请选择开票抬头",
            trigger: "change",
          },
          'ratepayerNo': {
            required: true,
            message: "请输入纳税人识别号",
            trigger: "blur",
          },
          'businessAddress': {
            required: true,
            message: "请输入营业地址",
            trigger: "blur",
          },
          'bankOfDeposit': {
            required: true,
            message: "请输入开户行",
            trigger: "blur",
          },
          'accountNumber': {
            required: true,
            message: "请输入账号",
            trigger: "blur",
          },
          'telephone': {
            required: true,
            message: "请输入电话",
            trigger: "blur",
          },

        },
      }
    },
    created() {
      this.GetFinancialProject();
      // 部门列表
      this.getDepartList();
    },
    methods: {
      //财务  获取项目列表
      GetFinancialProject() {
        let data = {
          searchVal: "",
          pageSize: 100000000,
          pageNum: 1,
        };
        xz.getplancomrecordprojectlist(data, '0383e791-72fd-4edc-aa70-2bcadminuser').then(
          (res) => {
            // console.log('项目名称列表', res)
            if (res.status == "ok") {
              this.projectList = res.data;
            } else {
              this.projectList = [];
            }
          }
        );
      },
      // 获取部门列表
      getDepartList() {
        xz.getorganstr('', localStorage.loginRoletype, {
          strIsDisable: 1
        }).then(res => {
          if (res.status == 'ok') {
            this.departList = res.msg.parent[0].children
          } else {
            this.departList = []
          }
        })
      },
      //初始化
      getDetail(type) {
        if (this.formQuery.ownershipId) {
          let data = {
            type: this.formQuery.type,
            ownershipId: this.formQuery.ownershipId,
            invoiceId: this.id
          };
          xz.IvoiceFun(data, "GetInvoiceLoadEdit").then((res) => {
            if (res.status == "ok") {
              this.custname = res.data.strCustName;
              this.invoiceTitles = res.data.invoiceTitles;
              this.finalStatement = res.data.finalStatement;
              this.emailList = res.data.projectEmail;
              this.legList = res.data.subjectOfContract;
              if (res.data.invoiceTitles == 1) {
                this.formQuery.accountNumber = res.data.accountNumber;
                this.formQuery.bankOfDeposit = res.data.bankOfDeposit;
                this.formQuery.businessAddress = res.data.businessAddress;
                this.formQuery.invoiceTitle = res.data.invoiceTitle;
                this.invoiceTitle = {
                  id: this.formQuery.invoiceTitle,
                };
                this.formQuery.telephone = res.data.telephone;
                this.formQuery.ratepayerNo = res.data.ratepayerNo;
              }
              this.formQuery.newEmail = res.data.newEmail;
              this.formQuery.projectEmailIds = res.data.projectEmailIds;
              this.formQuery.subjectOfLegalAffairsId =
                res.data.subjectOfLegalAffairsId;
              if (this.formQuery.subjectOfLegalAffairsId) {
                this.GetBillingItem()
              }

              this.finalStatement.forEach((element) => {
                this.$set(element, "ttAmount", 0);
              });
              this.handleSelectionChange(this.finalStatement, 0)
              this.$refs.multipleTable.toggleAllSelection()
              // console.log(this.formQuery)
            }
          });
        }
      },
      changeNewTitle(val) {
        if (val != undefined && val) {
          this.formQuery.invoiceTitle = '';
          this.invoiceTitle = '';
        }
      },
      departChange(val) {
        if (val) {
          this.formQuery.ownershipId = val[val.length - 1];
          this.getDetail("");
        } else {
          this.formQuery.ownershipId = "";
        }
      },
      changeInvoiceTitle(val) {
        if (val.id != undefined && val.id) {
          this.formQuery.invoiceTitle = val.id;
          this.formQuery.accountNumber = val.bankAccount;
          this.formQuery.ratepayerNo = val.account;
          this.formQuery.businessAddress = val.businessAddress;
          this.formQuery.bankOfDeposit = val.openingBank;
          this.formQuery.telephone = val.phoneNum;
        }
      },
      //选择主体
      changeLeg(val) {
        if (val) {
          this.GetBillingItem()
        }
      },
      handleExceed() {
        this.$message.warning(`当前限制最多上传 5 个文件`);
      },
      // 删除结算单
      handleFileRemove() {},
      // 上传结算单
      success_handle(file) {
        const formData = new FormData();
        formData.append("pagename", "docinf");
        formData.append("action", "save");
        formData.append("userid", Cookies.get("userid-b"));
        formData.append("entid", Cookies.get("userid-b"));
        formData.append("excel", file.raw, file.name);
        // console.log("formData", formData);
        xz.uploadCert(formData).then((res) => {
          if (res) {
            this.formQuery.invoiceFiles.push(res);
          } else {}
        });
      },
      // 表格多选
      handleSelectionChange(val) {
        if (val[0] != undefined) {
          this.multipleSelection = val;
          let sum = 0;
          this.formQuery.invoiceFiles = [];
          this.stateFileList = [];
          this.formQuery.invoiceForFinalStatementsList = [];
          this.multipleSelection.forEach((element) => {
            this.formQuery.invoiceFiles = this.formQuery.invoiceFiles.concat(element.files);
            this.stateFileList = this.stateFileList.concat(element.files);
            sum = math.format(
              math.add(
                math.bignumber(Number(sum)), math.bignumber(Number(element.ttAmount))
              )
            )
            let d = {
              finalStatementId: element.finalStatementId,
              amount: Number(element.ttAmount),
              invoiceForFinalStatementId: ''
            };
            this.formQuery.invoiceForFinalStatementsList.push(d);
          });
          this.stateFileList.forEach(element => {
            this.$set(element, 'url', element.fileUrl)
            this.$set(element, 'name', element.fileName)
          });
          this.$nextTick(() => {
            this.settlementAmountSum = sum;
          })
        }
      },
      changeBilling2(key) {
        xz.GetTicketType(key, this.subjectOfLegalAffairsId).then(
          (res) => {
            if (res.status == "ok") {
              this.ticketTypeList2 = res.data;
            } else {
              this.ticketTypeList2 = [];
            }
          })
        this.formQuery.actualBillingTakeOut.invoiceTypeId = ''
      },
      changeTTAmount(i) {
        let sum = 0;
        this.formQuery.invoiceForFinalStatementsList = [];
        this.multipleSelection.forEach((element) => {
          sum = math.format(
            math.add(
              math.bignumber(Number(sum)), math.bignumber(Number(element.ttAmount))
            )
          )
          let d = {
            finalStatementId: element.finalStatementId,
            amount: Number(element.ttAmount),
            invoiceForFinalStatementId: ''
          };
          this.formQuery.invoiceForFinalStatementsList.push(d);
        });
        this.settlementAmountSum = sum;
      },
      changeBilling(val) {
        console.log('111', val)
        if (val) {
          try {
            this.taxRate = parseFloat(val.value.match(/\d+/)[0]) / 100;
          } catch (e) {}
          if (val.value.indexOf('差额') > -1 && this.formQuery.actualBillingTakeOut == null) {
            this.formQuery.actualBillingTakeOut = {
              billingItemId: val.key,
              invoiceTypeId: '',
              projectKey: '',
              details: [{
                billingItemDetailsId: '',
                projectName: '',
                deductionAmount: 0,
                quantity: '',
                unit: '',
                specification: '',
              }]
            }
            this.formQuery.actualBillingMain = null;
          } else if (val.value.indexOf('全额') > -1 && this.formQuery.actualBillingMain == null) {
            this.formQuery.actualBillingMain = {
              billingItemId: '',
              invoiceTypeId: '',
              projectKey: '',
              details: [{
                billingItemDetailsId: '',
                taxInclusiveLabel: '',
                invoiceAmount: 0,
                quantity: '',
                unit: '',
                specification: '',
              }]
            }
          }
          if (this.formQuery.isConsolidatedBilling == 1 || (this.formQuery.actualBillingMain != null && this.formQuery.isConsolidatedBilling == 0)) {
            this.formQuery.actualBillingMain.billingItemId = val.key;
            this.formQuery.actualBillingMain.invoiceTypeId = '';
            this.invoiceTypeId = '';
            this.formQuery.actualBillingMain.details[0].billingItemDetailsId = '';
            this.GetTicketType(val.key)
          } else {
            this.GetTicketType2(val.key)
            this.formQuery.actualBillingTakeOut.details[0].billingItemId = val.key;
          }
          this.businessTypeId = val.businessTypeId;
          this.Billing = val.value;
          // this.GetBillingItemDetails(val.key)
          const regex = /\((.*?)\)/g;
          const matches = val.value.match(regex);
          let rate = matches.map(match => match.replace(/\(|\)/g, ''))[0];
          rate = rate.replace('%', '');
          this.rate = Number(rate) / 100;
          this.BillingConList = [];
          this.isBuild = false;
        }
      },
      //获取票种列表
      GetTicketType(key) {
        xz.GetTicketType(key, this.formQuery.subjectOfLegalAffairsId).then(
          (res) => {
            if (res.status == "ok") {
              this.ticketTypeList = res.data;
            } else {
              this.ticketTypeList = [];
            }
          }
        );
      },
      GetTicketType2(key) {
        xz.GetTicketType(key, this.subjectOfLegalAffairsId).then(
          (res) => {
            if (res.status == "ok") {
              this.ticketTypeList2 = res.data;
            } else {
              this.ticketTypeList2 = [];
            }
          })
      },
      changeTicketTypeId(val) {
        if (val.key != undefined && val.key) {
          this.formQuery.actualBillingMain.invoiceTypeId = val.key;
          this.GetBillingItemDetails(this.formQuery.actualBillingMain.billingItemId);
          this.formQuery.actualBillingMain.details[0].billingItemDetailsId = '';
          this.formQuery.actualBillingMain.projectKey = '';
        }
      },
      GetBillingItemDetails(key) {
        let d = {
          key,
          TicketTypeId: this.formQuery.actualBillingMain != null ? this.formQuery.actualBillingMain.invoiceTypeId : this.formQuery.actualBillingTakeOut.invoiceTypeId,
          Projectid: this.ownershipId
        }
        xz.GetBillingItemDetails(d).then((res) => {
          if (res.status == "ok") {
            this.BillingConList = res.data;
            if (this.BillingConList2.length == 0) {
              this.BillingConList2 = res.data;
            }
          } else {
            this.BillingConList = [];
          }
        });
      },
      //选择开票内容
      changeBillingItemDetails(val) {
        if (val != undefined && val) {
          const item = this.BillingConList.find(e => e.key == val);
          if (item.value.indexOf('建筑服务') > -1) {
            this.isBuild = true;
          } else {
            this.isBuild = false;
          }
          try {
            let item = this.BillingConList.find(e => e.key == val);
            this.projectKeyList = item.projectKey;
            if (item.projectKey.length > 0) {
              if (this.formQuery.actualBillingMain != undefined && this.formQuery.actualBillingMain != null) {
                this.formQuery.actualBillingMain.projectKey = item.projectKey[0].key
              } else {
                this.formQuery.actualBillingTakeOut.projectKey = item.projectKey[0].key
              }
            }
          } catch (e) {
            this.projectKeyList = [];
          }
        } else {
          this.isBuild = false;
        }
      },
      //选择开票内容
      changeBillingItemDetails2(val) {
        if (val != undefined && val) {
          try {
            let item = this.BillingConList2.find(e => e.key == val);
            this.projectKeyList2 = item.projectKey;
            if (item.projectKey.length > 0) {
              if (this.formQuery.actualBillingTakeOut != undefined && this.formQuery.actualBillingTakeOut != null) {
                this.formQuery.actualBillingTakeOut.projectKey = item.projectKey[0].key
              } else {
                this.formQuery.actualBillingTakeOut.projectKey = item.projectKey[0].key
              }
            }
          } catch (e) {
            this.projectKeyList2 = [];
          }
        } else {}
      },
      // 新增开票其他部分
      addContentHandle() {
        let query = {
          billingItemDetailsId: "", //开票内容id
          taxInclusiveLabel: 0, //是否含税1：含税0：不含税
          invoiceAmount: 0, //金额
        };
        this.formQuery.actualBillingMain.details.push(query);
      },
      // 删除开票其他部分
      dltContentHandle(i) {
        this.formQuery.actualBillingMain.details.splice(i, 1);
      },
      calMtpt() {
        let sum = 0;
        this.formQuery.actualBillingMain.details.forEach(e => {
          let amount;
          if (e.taxInclusiveLabel == 0) {
            let tax = e.invoiceAmount * this.taxRate;
            console.log('tax', e.invoiceAmount, this.taxRate);
            amount = math.format(
              math.add(
                math.bignumber(Number(e.invoiceAmount)), math.bignumber(Number(tax))
              )
            )
          } else {
            amount = e.invoiceAmount;
          }
          sum = math.format(
            math.add(
              math.bignumber(Number(sum)), math.bignumber(Number(amount))
            )
          )
        });
        this.mTpt = parseFloat(sum);
      },
      getDeductionAmountSum() {
        let sum = 0;
        this.formQuery.actualBillingTakeOut.details.forEach(element => {
          sum = math.format(
            math.add(
              math.bignumber(Number(sum)), math.bignumber(Number(element.deductionAmount))
            )
          )
        });
        this.deductionAmountSum = sum;
      },
      changeInvoiceType2(val) {
        let d = {
          key: this.formQuery.actualBillingTakeOut.billingItemId,
          TicketTypeId: this.formQuery.actualBillingTakeOut.invoiceTypeId,
          Projectid: this.ownershipId
        }
        xz.GetBillingItemDetails(d).then((res) => {
          if (res.status == "ok") {
            this.BillingConList2 = res.data;
          } else {
            this.BillingConList2 = [];
          }
        });
      },
      addKcItem() {
        let data = {
          billingItemDetailsId: '',
          projectName: '',
          deductionAmount: null
        }
        this.formQuery.actualBillingTakeOut.details.push(data)
      },
      delKcItem(index) {
        this.formQuery.actualBillingTakeOut.details.splice(index, 1)
        this.getDeductionAmountSum();
      },
      GetBillingItem() {
        xz.GetBillingItem(this.formQuery.subjectOfLegalAffairsId).then((res) => {
          if (res.status == "ok") {
            this.BillingList = res.data;
          } else {
            this.BillingList = [];
          }
        });
      },
      submit(status) {
        this.$refs.statementForm.validate((valid) => {
          if (valid) {
            this.isBtnLoading = true;
            this.formQuery.isOffline = status;
            xz.IvoiceFun(this.formQuery, "SetNoRequestForBilling").then((res) => {
              if (res.status == "ok") {
                this.$message.success(status ? "开票成功" : "手工登记开票成功");
                this.isBtnLoading = false;
                this.isSuccess = true;
                setTimeout(() => {
                  this.backHandle()
                }, 1000);
              } else {
                this.$message.error(res.msg);
                this.isBtnLoading = false;
              }
            });
          }
        })
      },
      // 取消
      backHandle() {
        window.close()
      },
      changeAccountType() {
        if (this.formQuery.xAccount.accountType == 1) {
          let d = {
            keyWord: "",
            pageSize: 100,
            legalsubid: this.formQuery.subjectOfLegalAffairsId,
            UserId: Cookies.get("userid-b")
          }
          xz.BasicFun(d, "GetGeneralAccount").then((res) => {
            if (res.status == "ok") {
              this.accountList = res.data;
            } else {
              accountList = [];
            }
          });
        } else {
          this.formQuery.xAccount.bankAccount = '';
          this.formQuery.xAccount.openingBank = '';
        }
      },
      changeBankAccount(val) {
        let item = this.accountList.find(e => e.value == val);
        this.formQuery.xAccount.openingBank = item.key;
      },
      changeConsolidatedBilling(val) {
        if (val == 1) {
          let id = JSON.parse(JSON.stringify(this.formQuery.actualBillingTakeOut.details[0].billingItemId));
          this.formQuery.actualBillingTakeOut.details[0].billingItemDetailsId = '';
          this.formQuery.actualBillingTakeOut.invoiceTypeId = '';
          this.formQuery.actualBillingTakeOut.details[0].billingItemId = '';
          this.formQuery.actualBillingMain = {
            billingItemId: id,
            invoiceTypeId: '',
            projectKey: '',
            details: [{
              billingItemDetailsId: '',
              taxInclusiveLabel: '',
              invoiceAmount: 0,
              quantity: '',
              unit: '',
              specification: '',
            }]
          }
          this.GetTicketType(id)
        }
      },
    }
  }
</script>

<style scoped>
  .f_foot_box {
    font-size: 14px;
    color: #555;
  }

  .flex_box {
    /* justify-content: space-around; */
    flex-wrap: wrap;
    padding-left: 15px;
  }

  .f_foot_box,
  .f_foot {
    align-items: center;
  }

  .t_sel {
    margin-left: 15px;
  }

  .f_foot {
    margin-left: 40px;
  }

  .foot_left_box {
    width: 80px;
  }

  .f_sel01 {
    margin-right: 10px;
  }

  .f_com_box {
    padding: 20px 5px;
  }

  .f_icon {
    font-size: 20px;
    color: #19bd92;
  }

  .f_list_box {
    margin-right: 80px;
    align-items: center;
    font-size: 14px;
    color: #555;
  }

  .f_left_box {
    text-align: right;
    width: 100px;
    margin-right: 5px;
  }

  .f_right_box {
    flex: 1;
  }

  .add_box {
    align-items: center;
    margin-top: 15px;
  }

  .btn01 {
    margin-left: 10px;
  }

  .mt15 {
    margin-top: 15px;
  }

  .pt20 {
    padding-top: 20px;
  }

  .com_style {
    background-color: #e8f7f7;
  }

  .i_radio_box {
    display: -webkit-box;
    /* align-items: center; */
  }

  .i_box {
    margin-left: 30px;
  }

  .print_box {
    justify-content: flex-end;
  }

  .com_form_box {
    margin: 15px 0;
  }

  .d_txt {
    font-size: 14px;
    color: #555;
    margin-top: 20px;
  }

  .btn_box {
    display: flex;
    justify-content: center;
    margin-top: 30px;
  }

  .line_box {
    width: 3px;
    height: 16px;
    background-color: #19bd92;
    margin-right: 4px;
  }

  .dtl_table {
    box-sizing: border-box;
    margin-top: 15px;
  }

  .emp_txt {
    width: 90px;
    text-align: right;
    font-size: 14px;
    color: #555;
    padding: 0 10px 0 0;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
  }

  .tips {
    color: #598DE7;
    font-size: 13px;
    margin-left: 20px;
  }

  .r_edit_title {
    display: flex;
    align-items: center;
    font-size: 16px;
    line-height: 26px;
    font-weight: bold;
    color: #000;
    /* border-bottom: 1px solid #DCDFE6; */
  }

  .emp_form_txt {
    width: 370px;
    font-size: 14px;
    color: #000;
  }

  .txts01 {
    font-size: 14px;
  }

  .p_employee_item {
    display: flex;
    align-items: center;
    margin-bottom: 12px;
    margin-right: 3px;
  }

  .p_employee_form.p_employee_form01 {
    margin-top: 0;
  }

  .p_employee_form {
    display: flex;
    flex-wrap: wrap;
    margin-top: 10px;
  }

  .p_employee_box {
    background-color: #fff;
    padding: 15px 10px;
  }

  .qrTips {
    text-align: center;
    font-size: 14px;
    color: red;
    margin-top: 10px;
  }

  .ceBox {
    padding-left: 30px;
    padding-bottom: 20px;
  }

  .ceTitle {
    font-weight: bold;
    font-size: 14px;
    padding-top: 9px;
  }

  .ckbox {
    margin-left: 120px;
    margin-bottom: 10px;
  }

  .ckbox2 {
    margin-left: 40px;
    margin-bottom: 10px;
  }

  .huo {
    line-height: 32px;
    margin: 0 10px;
    font-size: 14px;
  }

  .blueName {
    line-height: 32px;
  }

  .req {
    color: red;
    margin-right: 3px;
  }

  .redTips {
    color: red;
    font-size: 13px;
    margin-left: 20px;
  }

  .merge {
    padding: 10px 30px;
  }

  .sumAmount {
    font-weight: bold;
    margin-left: 150px;
  }

  .applyMore {
    font-size: 18px;
    font-weight: bold;
    margin-left: 30px;
  }

  .splitLine {
    width: 100%;
    border-top: #CCC 2px dashed;
    margin-bottom: 25px;
  }

  .kptip {
    color: #598DE7;
    margin-top: 10px;
    padding-left: 30px;
  }

  .tabBox {
    background: #fff;
    padding: 30px;
    /* width: 800px; */
  }

  .invTitle {
    width: 800px;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .reimbursementTitle {
    text-align: center;
    margin-bottom: 3px;
    font-size: 24px;
    color: #800000;
  }

  .invType {
    margin-left: 30px;
    font-size: 14px;
    color: #000;
    min-width: 150px;
  }

  .invNum {
    color: #800000;
    margin-bottom: 5px;
  }

  .centerTitle {
    margin-bottom: 5px;
    font-size: 20px;
  }

  .invoiceTable {
    margin-top: 10px;
    width: 800px;
    background-color: #fff;
    padding: 8px 0;
    /* line-height: 40px; */
  }

  .tabBox table td,
  .tabBox table th {
    border: #800000 1px solid !important;
  }

  .tabBox table {
    border: #800000 1px solid !important;
  }

  .tabBox_title {
    background: #f6f6f6;
  }

  .font-center {
    text-align: center
  }

  .titfont {
    font-family: 微软雅黑;
    padding: 10px 0;
    color: #800000;
  }

  .titfont2 {
    padding: 20px 0;
  }

  .rowItem {
    font-size: 14px;
    padding-left: 5px;
  }

  .mt {
    margin-top: 30px;
  }

  .rowTitle {
    font-size: 13px;
    color: #800000;
  }

  .invInfoBox {
    height: 180px;
    padding: 5px 0;
    position: relative;
  }

  .invItem {
    width: 100px;
    text-align: center;
    color: #800000;
  }

  .invInfoLine {
    margin-top: 5px;
    color: #000;
  }

  .invInfoItem {
    text-align: center;
    width: 100px;
  }

  .invInfoBot {
    position: absolute;
    bottom: 5px;
  }

  .amountLine {
    line-height: 32px;
  }

  .invRemake {
    margin-left: 5px;
  }

  /* 水印 */
  .invInfoBox::before {
    content: "仅供开票预览";
    position: absolute;
    top: 12%;
    left: 24%;
    transform: translate(-50%, -50%);
    transform: rotate(30deg);
    opacity: 0.4;
    letter-spacing: 20px;
    font-size: 54px;
    color: #ccc;
    position: none;
  }

  .deductionAmountSum {
    margin-left: 30px;
    font-weight: bold;
    line-height: 32px;
    white-space: nowrap;
  }

  .kcTitle {
    line-height: 32px;
    margin: 0 5px;
    white-space: nowrap;
  }

  .addbtn {
    white-space: nowrap;
    margin: 0 5px;
  }
</style>
<style>
  .page_noApplicationInv .f_sel_box .el-select {
    width: 150px;
  }

  .page_noApplicationInv .dtl_table .el-table,
  .page_noApplicationInv .dtl_table .el-table th.el-table__cell,
  .i_list.el-table tr {
    background-color: #e8f7f7;
    /* 你想要的背景色 */
  }

  .form_table td {
    border: #000 1px solid;
  }

  .e_dtl_content .el-table .el-table__cell {
    padding: 4px 0;
  }

  .page_noApplicationInv .el-input__icon {
    height: 32px;
    line-height: 32px;
  }

  .page_noApplicationInv .doc_table .el-table__body td.el-table__cell {
    padding: 5px 0;
  }

  .page_noApplicationInv .doc_table .el-table__body th.el-table__cell {
    padding: 8px 0;
  }

  .page_noApplicationInv .injuryTabBtn .el-button--text {
    color: #19bd92;
    font-size: 13px;
    padding: 0;
  }

  .page_noApplicationInv .el-radio {
    margin-right: 15px;
  }
</style>